<mat-form-field class="dict-krk">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option *ngIf="krkDocuments">
      <ngx-mat-select-search [formControl]="ofwcaFilterCtrl" placeholderLabel="Wprowadź nazwę OFWCA..."
                             noEntriesFoundLabel="Nie znaleziono KRK">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of items"
                [value]="option.uuid">
      {{option.ofwca.firstName}} {{option.ofwca.lastName}} (PESEL: {{option.ofwca.pesel}}), z dnia {{option.createdAt | date:'y-MM-dd'}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
